import { render } from "./MessageAudio.vue?vue&type=template&id=564942b1&scoped=true"
import script from "./MessageAudio.vue?vue&type=script&lang=js"
export * from "./MessageAudio.vue?vue&type=script&lang=js"

import "./MessageAudio.vue?vue&type=style&index=0&id=564942b1&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564942b1"]])

export default __exports__